import {
	instance
} from '../../util/http'
import apis from '../../config/apis'

// 获取会员信息
const userMaintenance = () => {
	return instance.get(apis.Maintenance.userMaintenance)
}
// 更换服务人
const applyChangeService = (data) => {
	return instance.post(apis.Maintenance.applyChangeService, data)
}
// 申请记录 getApplyRecordList
const getApplyRecordList = (pageNo,pageSize) => {
	return instance.get(apis.Maintenance.getApplyRecordList + '?Page=' + pageNo + '&PageSize=' + pageSize)
}
// 客情维护 
const getMaintenanceList = (pageNo,pageSize) => {
	return instance.get(apis.Maintenance.getMaintenanceList + '?Page=' + pageNo + '&PageSize=' + pageSize)
}
// 驳回
const rejectMaintenance = (data) => {
	return instance.put(apis.Maintenance.rejectMaintenance, data)
}
// 客情维护数量 getMaintenanceCount
const getMaintenanceCount = () => {
	return instance.get(apis.Maintenance.getMaintenanceCount)
}
export default {
	userMaintenance,
	applyChangeService,
	getApplyRecordList,
	getMaintenanceList,
	rejectMaintenance,
	getMaintenanceCount
}